import { UserSchool } from 'src/app/libs/shared/models/user.model';

export function selectUserSchool(userSchools: any): UserSchool {

    if (Array.isArray(userSchools) && userSchools.length > 0) {
        return userSchools[0];
    }
    return null;
}
